import IBookingInterval from "~/interfaces/IBookingInterval"

export const intervalKindFor = (interval: IBookingInterval) => {
  if (!interval) return "nightly"

  const [sHour, sMinute] = interval.start_time.split(":").map((v) => parseInt(v))
  const [eHour, eMinute] = interval.end_time.split(":").map((v) => parseInt(v))

  return sHour < eHour ? "daily" : "nightly"
}
